<script>
  import { onMount } from "svelte";

  import { liveQuery } from 'dexie';

  import { db } from "../db.js";
  import { getABI, getContractValue, updateTxs } from "../utils.js";

  import Columns from './charts/columns.svelte';

  export let chain;
  export let address;
  export let loading;

  const columns = [
    { key: 'day', label: 'Date' },
    { key: 'amount', label: 'Amount', value: true }
  ];

  let price;
  let data;

  let txs = liveQuery( () => db.txs.where('[chain+to]').equals([ chain, address ]).sortBy('timeStamp') );

  $: $txs || price, process();

  const init = async () => {
    await updateTxs(chain, address, undefined, loading);
    const abi = await getABI(address, chain);
    const priceMethod = abi.find(m => m.type === 'function' && m.name === 'price');
    if (priceMethod) {
      price = parseInt(await getContractValue(chain, address, 'price'));
    }
  }

  const process = () => {
    if ($txs &&  price) {
      const byDay = {};
      for (const tx of $txs) {
        if (!tx.isError) {
          let date = new Date(tx.timeStamp * 1000);
          date = date.toLocaleDateString();
          if (!Object.keys(byDay).includes(date)) {
            byDay[date] = 0;
          }
          byDay[date] += (tx.value / price);
        }
      }
      data = Object.entries(byDay).map(([ day, amount ]) => ({ day, amount }));
    }
  }

  onMount(init);
</script>

{#if data}
  <Columns class={ $$props.class } { data } { columns } />
{:else}
  Loading...
{/if}